import { ToggleOn } from "@mui/icons-material";
import { Icon, IconButton, Menu, MenuItem, Tooltip } from "@mui/material";
import { useState } from "react";

export const AddButton=({title,onClick,disabled=false})=>(
  <IconButton color="info" title={title} onClick={onClick} disabled={disabled}>
    <Icon>
      add
    </Icon>
  </IconButton>
)

export const EditButton=({title,onClick,disabled=false})=>(
  <IconButton color="success" title={title} onClick={onClick} disabled={disabled}>
    <Icon>
      edit
    </Icon>
  </IconButton>
)

export const DelButton=({title,onClick,disabled=false})=>(
  <IconButton color="error" title={title} onClick={onClick} disabled={disabled}>
    <Icon>
      <ToggleOn/>
    </Icon>
  </IconButton>
)

export const ActiveButton=({title,onClick,disabled=false})=>(
  <IconButton color="success" title={title} onClick={onClick} disabled={disabled}>
    <Icon>
      <ToggleOn/>
    </Icon>
  </IconButton>
)

export const SyncButton=({title,onClick,disabled=false})=>(
  <IconButton color="info" title={title} onClick={onClick} disabled={disabled}>
    <Icon>sync
    </Icon>
  </IconButton>
)

export const PrintButton=({title,onClick,disabled=false})=>(
  <IconButton color="info" title={title} onClick={onClick} disabled={disabled}>
    <Icon>print
    </Icon>
  </IconButton>
)

export const CustomPrintButton=({title,onClick,color,disabled=false})=>(
  <Tooltip title={title}>
    <IconButton color={color} onClick={onClick} disabled={disabled}>
      <Icon>print</Icon>
    </IconButton>
  </Tooltip>  
)

export const DeleteButton=({title,onClick,disabled=false})=>(
  <IconButton color="error" title={title} onClick={onClick} disabled={disabled}>
    <Icon>
      delete
    </Icon>
  </IconButton>
)

export const CancelButton=({title,onClick,disabled=false})=>(
  <IconButton color="error" title={title} onClick={onClick} disabled={disabled}>
    <Icon>
      cancel
    </Icon>
  </IconButton>
)

export const MoreButton = ({options}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (e) => {
    setAnchorEl(e.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <>
    <IconButton color="info" onClick={handleClick}>
      <Icon>more_vert</Icon>
    </IconButton>
      <Menu MenuListProps={{
        sx:{
        }
      }} anchorEl={anchorEl} open={open} onClose={handleClose} PaperProps={{
        sx:{
          border:"1px solid #1a73e8"
        }
      }}>
        {options.map((option,i)=>(
          <MenuItem key={i} disabled={option.disabled} onClick={option.onClick}><Icon sx={{mr:1}} color="info">{option.icon?option.icon:"add"}</Icon>{option.label}</MenuItem>
        ))}
         
      </Menu>
    </>
  );
};
